// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V3jR","toggleWrap":"styles_toggleWrap__3k3Qn","content":"styles_content__2zsuS","selectAreaCode":"styles_selectAreaCode__3saui"};